import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";
const initialState = {
  loading: false,
  PAYMENTSLISTDATA: [],
  totalAmount: 0,
  totalCount: 0,
  subscription: [],
  transaction: [],
  subTotal: 0,
  tranTotal: 0,
};
const slice = createSlice({
  name: "PAYMENTSLISTDATA",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.TokenRevenueList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.TokenRevenueList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      PAYMENTSLISTDATA: payload?.data?.payments || [],
      totalAmount: payload?.data?.total || 0,
      totalCount: payload?.totalcount || 0,
    }));
    builder.addCase(Act.TokenRevenueList.rejected, (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload || "Unknown error",
      PAYMENTSLISTDATA: [],
      totalAmount: 0,
      totalCount: 0,
    }));
    builder.addCase(Act.ImagesToken.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.ImagesToken.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      PAYMENTSLISTDATA: payload || [],
      totalCount: payload?.totalcount || 0,
    }));
    builder.addCase(Act.ImagesToken.rejected, (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload || "Unknown error",
      PAYMENTSLISTDATA: [],
      totalCount: 0,
    }));

    builder.addCase(Act.SubscriptionRevenueList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(
      Act.SubscriptionRevenueList.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        subscription: payload.data || [],
        subTotal: payload?.totalcount || 0,
      })
    );
    builder.addCase(
      Act.SubscriptionRevenueList.rejected,
      (state, { payload }) => ({
        ...state,
        loading: false,
        error: payload || "Unknown error",
        subscription: [],
        subTotal: 0,
      })
    );

    builder.addCase(Act.TransactionRevenueList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(
      Act.TransactionRevenueList.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        transaction: payload.data || [],
        tranTotal: payload?.totalcount || 0,
      })
    );
    builder.addCase(
      Act.TransactionRevenueList.rejected,
      (state, { payload }) => ({
        ...state,
        loading: false,
        error: payload || "Unknown error",
        transaction: [],
        tranTotal: 0,
      })
    );
  },
});

export default slice;
